import { Button, Grid, TextField, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import colors from '../../../../assets/colors'

// Contratar (com desconto e quantidade) e editar o desconto de um add-on do
// cliente. `dialog` é o pedido em aberto: { mode: 'contract' | 'edit', service,
// contract, initialDiscount } — null fecha o modal.
const DiscountDialog = ({ dialog, onClose, onConfirm }) => {
  const classes = filterStylesComponents()

  const [discount, setDiscount] = useState(0)
  const [quantity, setQuantity] = useState(1)

  const isEdit = dialog?.mode === 'edit'
  // add-on por quantidade contratado já com N: contratar 1 e ajustar depois
  // geraria duas cobranças de pró-rata para a mesma intenção
  const askQuantity = !isEdit && dialog?.service?.type === 'quantity'

  useEffect(() => {
    if (dialog) {
      setDiscount(dialog.initialDiscount || 0)
      setQuantity(1)
    }
  }, [dialog])

  const handleChangeDiscount = e => {
    const value = Math.min(100, Math.max(0, parseInt(e.target.value, 10) || 0))
    setDiscount(value)
  }

  return (
    <BaseFilterModal
      open={!!dialog}
      title={isEdit ? 'Editar desconto' : 'Contratar serviço adicional'}
      hiddenHelpButton
      handleOpen={onClose}
    >
      <Grid item xs={12} style={{ width: '380px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography style={{ fontWeight: 700, color: colors.textCustom }}>
              {dialog?.service?.name}
            </Typography>
          </Grid>

          {askQuantity && (
            <Grid item xs={12}>
              <TextField
                label="Quantidade"
                type="number"
                value={quantity}
                onChange={e => setQuantity(e.target.value)}
                onBlur={() =>
                  setQuantity(Math.max(1, parseInt(quantity, 10) || 1))
                }
                fullWidth
                inputProps={{ min: 1 }}
                helperText="Contratado de uma vez: gera uma única cobrança do valor proporcional."
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <TextField
              label="Desconto (%)"
              type="number"
              value={discount}
              onChange={handleChangeDiscount}
              fullWidth
              inputProps={{ min: 0, max: 100 }}
              helperText={
                isEdit
                  ? 'O preço do add-on é recalculado com o novo desconto (0–100%).'
                  : 'Desconto manual congelado no momento da contratação (0–100%).'
              }
            />
          </Grid>

          <Grid
            item
            xs={12}
            container
            alignItems="center"
            justifyContent="flex-end"
          >
            <Button
              type="button"
              onClick={onClose}
              className={classes.btnMoreFilters}
            >
              Voltar
            </Button>

            <Button
              type="button"
              onClick={() =>
                onConfirm(discount, Math.max(1, parseInt(quantity, 10) || 1))
              }
              className={classes.btnAdd}
            >
              {isEdit ? 'Salvar' : 'Contratar'}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default DiscountDialog
